import * as Sentry from '@sentry/nextjs';

import { DeviceCheckResult } from '~/generated/graphql';
import checkKioskMode from '~/helpers/deviceChecks/checkKioskMode';
import getOsInfo from '~/helpers/deviceChecks/getOsInfo';
import { DeviceCheckMetadata } from '~/types';

const checkDeviceLockdown: DeviceCheckMetadata['check'] = async ({
  registrationDetails,
}) => {
  try {
    const os = await getOsInfo(navigator.userAgent, registrationDetails);
    const isKioskMode = await checkKioskMode(os?.name, registrationDetails);

    if (!os || isKioskMode === undefined) {
      return {
        result: DeviceCheckResult.Fail,
      };
    }

    if (isKioskMode) {
      return {
        result: DeviceCheckResult.Pass,
        value: String(isKioskMode),
      };
    }

    throw new Error('Error checking device lockdown state');
  } catch (err) {
    const e = err as Error;
    const error = new Error(
      JSON.stringify({
        error: e.message,
        registrationDetails,
      }),
    );

    Sentry.captureException(error);

    return {
      result: DeviceCheckResult.Fail,
      value: e.message,
    };
  }
};

export default checkDeviceLockdown;
